import React from "react";
import { styles } from "./ScrollCard.style";
import type { ScrollCardItem } from "../../ScrollCards";

interface ScrollCardProps {
  card: ScrollCardItem;
  index: 0 | 1 | 2 | 3;
  top: number;
  marginBottom: number;
  marginTop: number;
  height?: number;
}

export const ScrollCard = React.forwardRef<HTMLDivElement, ScrollCardProps>(
  ({ card, index, top, marginBottom, marginTop, height }, ref) => (
    <div
      ref={ref}
      className={styles.card({ index })}
      style={{
        backgroundColor: card.color,
        top: `${top}px`,
        marginBottom: `${marginBottom}px`,
        marginTop: `${marginTop}px`,
        height: height ? `${height}px` : undefined,
      }}
    >
      {card.heading && <p className={styles.badge()}>{card.heading}</p>}
      {card.text && <p className={styles.bodyText(!!card.heading)}>{card.text}</p>}
    </div>
  ),
);

ScrollCard.displayName = "ScrollCard";
